import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import './Profile.css';

const SECTIONS = [
  { id: 'profile', label: 'Profile' },
  { id: 'subscription', label: 'Subscription' },
];

function Profile() {
  const { user, clearSession } = useAuth();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('profile');

  function handleLogout() {
    clearSession();
    navigate('/');
  }

  return (
    <div className="profile-page">
      <Link to="/" className="profile-brand">
        <img src="/logo.svg" alt="" className="profile-brand-icon" width="40" height="40" />
        <span className="al-logo">Numus</span>
      </Link>

      <div className="profile-shell">
        <aside className="profile-nav" aria-label="Account sections">
          {SECTIONS.map((section) => (
            <button
              key={section.id}
              type="button"
              className={`profile-nav-item${activeSection === section.id ? ' is-active' : ''}`}
              onClick={() => setActiveSection(section.id)}
              aria-current={activeSection === section.id ? 'page' : undefined}
            >
              {section.label}
            </button>
          ))}
        </aside>

        <section className="profile-content">
          {activeSection === 'profile' ? (
            <>
              <dl className="profile-fields">
                <div className="profile-field">
                  <dt>Name</dt>
                  <dd>{user?.name || '—'}</dd>
                </div>
                <div className="profile-field">
                  <dt>Email</dt>
                  <dd>{user?.email || '—'}</dd>
                </div>
              </dl>
              <button type="button" className="al-btn al-btn--dark profile-logout" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <p className="al-body profile-placeholder">Coming soon</p>
          )}
        </section>
      </div>
    </div>
  );
}

export default Profile;
